var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BRow',[_c('BCol',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"text-center"},[_c('LoaderIcon',{staticClass:"text-primary rotating",attrs:{"size":"2x"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }